import {AbilityType} from "@/enums";

export function useAbilityColors() {
    function getColor(type) {
        switch (type) {
            case AbilityType.Heal:
                return 'heal';
            case AbilityType.Damage:
                return 'damage';
            case AbilityType.Stun:
                return 'stun';
            case AbilityType.Buff:
                return 'buff';
            case AbilityType.Debuff:
                return 'debuff';
            case AbilityType.HoT:
                return 'hot';
            case AbilityType.DoT:
                return 'dot';
            default:
                return '';
        }
    }

    function getLabel(type) {
        switch (type) {
            case AbilityType.Heal:
                return 'Heal';
            case AbilityType.Damage:
                return 'Damage';
            case AbilityType.Stun:
                return 'Stun';
            case AbilityType.Buff:
                return 'Buff';
            case AbilityType.Debuff:
                return 'Debuff';
            case AbilityType.HoT:
                return 'HoT';
            case AbilityType.DoT:
                return 'DoT';
            default:
                return '';
        }
    }

    // Returns the CSS rgb() value for an ability color using the Vuetify theme
    // variable, so it can be applied to arbitrary style properties (e.g. borders,
    // icon fills). Falls back to null for unknown types so callers can default.
    function getColorCss(type) {
        const color = getColor(type);
        return color ? `rgb(var(--v-theme-${color}))` : null;
    }

    return {getColor, getLabel, getColorCss};
}
